__webpack_require__.p = "/Stronka_ITP_2023/";